document.addEventListener("DOMContentLoaded",()=>{
  const header=document.querySelector(".rv-header");
  const nav=document.getElementById("RigvedMainNav");
  const menu=document.querySelector(".rv-menu");

  const closeMenu=()=>{
    if(!header||!nav||!menu)return;
    header.classList.remove("rv-menu-open");
    nav.classList.remove("show");
    menu.setAttribute("aria-expanded","false");
    menu.setAttribute("aria-label","Open menu");
    document.body.classList.remove("rv-nav-lock");
  };
  const openMenu=()=>{
    if(!header||!nav||!menu)return;
    header.classList.add("rv-menu-open");
    nav.classList.add("show");
    menu.setAttribute("aria-expanded","true");
    menu.setAttribute("aria-label","Close menu");
    document.body.classList.add("rv-nav-lock");
  };
  menu&&menu.addEventListener("click",()=>{
    header&&header.classList.contains("rv-menu-open")?closeMenu():openMenu();
  });
  nav&&nav.querySelectorAll("a").forEach(a=>a.addEventListener("click",closeMenu));
  document.addEventListener("click",e=>{
    if(header&&header.classList.contains("rv-menu-open")&&!header.contains(e.target))closeMenu();
  });
  document.addEventListener("keydown",e=>{if(e.key==="Escape")closeMenu();});
  window.addEventListener("resize",()=>{if(window.innerWidth>900)closeMenu();});

  document.querySelectorAll(".rv-add-form").forEach(f=>f.addEventListener("submit",async e=>{
    e.preventDefault();const fd=new FormData(f);
    try{const r=await fetch("/cart/add.js",{method:"POST",headers:{"Accept":"application/json"},body:fd});
      if(!r.ok)throw new Error("add failed");
      const t=document.getElementById("RigvedToast");if(t){t.textContent="Added to cart";t.classList.add("show");setTimeout(()=>t.classList.remove("show"),1800)}
      const count=document.querySelector(".rv-cart-count");if(count){const c=await fetch("/cart.js").then(x=>x.json());count.textContent=c.item_count}
    }catch(err){f.submit()}
  }));

  const wa=document.getElementById("RigvedWhatsApp");
  const waOpen=document.getElementById("RigvedWhatsAppOpen");
  const waClose=document.getElementById("RigvedWhatsAppClose");
  const toggleWa=(open)=>{if(!wa)return;wa.classList.toggle("show",open);wa.setAttribute("aria-hidden",open?"false":"true");};
  waOpen&&waOpen.addEventListener("click",()=>toggleWa(true));
  waClose&&waClose.addEventListener("click",()=>toggleWa(false));
  document.addEventListener("click",e=>{if(wa&&wa.classList.contains("show")&&!wa.contains(e.target)&&e.target!==waOpen)toggleWa(false)});
  document.addEventListener("keydown",e=>{if(e.key==="Escape")toggleWa(false)});
});